import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const RelatedArticles = ({ posts }) => {
  if (!posts || posts.length === 0) {
    return null;
  }

  return (
    <section className="mt-16 md:mt-20 pt-10 border-t border-border">
      <h2 className="text-2xl md:text-3xl font-semibold text-foreground mb-8 text-center">
        Related Articles
      </h2>
      <div className="grid md:grid-cols-2 gap-8">
        {posts.map((related, index) => (
          <motion.div
            key={related.slug}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="bg-card rounded-xl shadow-lg overflow-hidden hover:shadow-primary/20 transition-shadow duration-300 group"
          >
            <Link to={`/blog/${related.slug}`} className="block" aria-label={`Read more about ${related.title}`}>
              <img 
                src={related.image} 
                alt={`Featured image for ${related.title}`}
                className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                width="400"
                height="192"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-foreground mb-2 group-hover:text-primary transition-colors">{related.title}</h3>
                <p className="text-sm text-muted-foreground mb-3 line-clamp-2">{related.excerpt}</p>
                <span className="text-xs text-primary font-medium group-hover:underline">Read More &rarr;</span>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default RelatedArticles;